// extracted by mini-css-extract-plugin
export default {"DocumentationPage":"DocumentationPage_DocumentationPage__MjGNo","context":"DocumentationPage_context__WXdTv","printButton":"DocumentationPage_printButton__v-GOC"};